import { render, staticRenderFns } from "./BranchsKamsSopportDetailModal.vue?vue&type=template&id=d957eefa"
import script from "./BranchsKamsSopportDetailModal.vue?vue&type=script&lang=js"
export * from "./BranchsKamsSopportDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports